import React from 'react';
import { cn } from '@/lib/utils';

interface FloatingLabelProps {
  text: string;
  icon: React.ReactNode;
  position?: 'left' | 'right';
  className?: string;
}

const FloatingLabel: React.FC<FloatingLabelProps> = ({ text, icon, position = 'left', className }) => {
  return (
    <div className={cn(
      "flex items-center gap-2 px-3 lg:px-4 py-1.5 lg:py-2 rounded-full bg-card/50 backdrop-blur-sm shadow-lg text-xs lg:text-sm",
      className
    )}>
      <span className="text-primary">{icon}</span>
      <span className="text-foreground font-medium">{text}</span>
    </div>
  );
};

export default FloatingLabel; 